import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const Component = lazy(() =>
  import("@scenes/SubscriptionPages/components/SubscriptionAnalyticsPage").then((module) => ({
    default: module.SubscriptionAnalyticsPage,
  }))
);

export const subscriptionAnalyticsNRO: NavigationRoutingObject = {
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("subscription-analytics-nro-heading", "Subscription Analytics"),
  pageNameForTracking: () => "Subscription Analytics",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("subscription-analytics-nro-description", "View analytics for your subscription groups"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("subscription_analytics");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  Component: Component,
  showInSearchResults: false,
};
